module.exports = "/dist/fbf51e5ef6dc07bf53bb2b6896a96b99.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-500italic.eot
// module id = 15
// module chunks = 0